import React from 'react';
import { socialApps, type SocialApp } from '@sso/core-utils';

import Amazon from '../icons/Amazon';
import Apple from '../icons/Apple';
import Facebook from '../icons/Facebook';
import Google from '../icons/Google';
import Wechat from '../icons/Wechat';

const components: Record<SocialApp, React.JSX.Element> = {
  [socialApps.apple]: <Apple />,
  [socialApps.amazon]: <Amazon />,
  [socialApps.google]: <Google />,
  [socialApps.wechat]: <Wechat />,
  [socialApps.facebook]: <Facebook />,
};

type Props = {
  app: SocialApp;
};

export const SocialLogo = ({ app }: Props) => components[app] ?? null;
